import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "lotUnits",
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Lot Units...",
      sortBy: "name",
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    lotUnits: function() {
      return this.$store.getters.lotUnitsForTable;
    },
  },
  created() {
    const jsConn = new JSConn();
    this.$store.dispatch("needLotUnits", jsConn).then(() => {
      this.dataLoaded = true;
    });
  },
};
